import { STAMMDATEN_API } from '@Constants/backendConstants';
import { getFrameLabel } from '@Constants/getFrameLabel';
import { type ApiContainerType } from '@Model';
import { EditFrameMode, EditFrameShell, type IEditFrame, useGuiBinder } from '@synqo/frontend-component-library';
import {
    ContainerTypeBillingSection,
    ContainerTypeMainSection,
    ContainerTypeRentSection,
    ContainerTypeStockSection,
} from './Sections';

// @ai-generated 2026-10-21T09:24:28+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5 (1M context)

interface IProps {
    frame: IEditFrame<ApiContainerType>;
}

export function ContainerTypeFrameBody({ frame }: IProps) {
    const containerType = frame.data;
    const baseApiObjectPath = `${STAMMDATEN_API}/container_types/${containerType.id}`;

    const binder = useGuiBinder<ApiContainerType>({
        data: containerType,
        meta: frame.meta,
        canEdit: frame.mode !== EditFrameMode.View,
        requestUpdateState: frame.requestUpdateState,
    });

    return (
        <EditFrameShell
            frame={frame}
            headerProps={{
                label: getFrameLabel('Container-Typ', frame.mode),
                resourceLabel: 'Container-Typ',
                ...frame.events,
            }}
            bannerProps={{
                mode: frame.mode,
                loading: frame.pendingAction !== undefined,
                ...frame.events,
            }}
        >
            <ContainerTypeMainSection binder={binder} />

            <ContainerTypeStockSection
                binder={binder}
                usesIndividualManagement={containerType.uses_individual_management}
            />

            <ContainerTypeRentSection
                binder={binder}
                baseApiObjectPath={baseApiObjectPath}
                requestUpdateState={frame.requestUpdateState}
            />

            <ContainerTypeBillingSection
                binder={binder}
                baseApiObjectPath={baseApiObjectPath}
                requestUpdateState={frame.requestUpdateState}
            />
        </EditFrameShell>
    );
}
